import { CartLinesUpdateEvent } from '@shopify/events';

function bind(form) {
  if (!(form instanceof HTMLFormElement) || form.dataset.ajaxCart === '1') return;
  form.dataset.ajaxCart = '1';

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });
    if (sectionIds.length) formData.set('sections', sectionIds.join(','));

    const quantity = Number(formData.get('quantity') || 1);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id') || ''), quantity }],
        promise: deferred.promise,
      })
    );

    const button = form.querySelector('.bpd__cta, [name="add"]');
    if (button instanceof HTMLButtonElement) button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) {
          deferred.resolve({
            cart: null,
            detail: { didError: true, source: 'brand-pdp' },
          });
          return;
        }
        return fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const mapped = CartLinesUpdateEvent.createCartFromAjaxResponse
              ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
              : cart;
            const cartPayload =
              mapped && typeof mapped === 'object'
                ? Object.assign({}, mapped, {
                    totalQuantity: mapped.totalQuantity ?? cart.item_count,
                    item_count: cart.item_count,
                  })
                : { totalQuantity: cart.item_count, item_count: cart.item_count };
            deferred.resolve({
              cart: cartPayload,
              detail: {
                didError: false,
                sections: data.sections || {},
                items: cart.items,
                itemCount: quantity,
                source: 'brand-pdp',
              },
            });
          });
      })
      .catch((error) => deferred.reject(error))
      .finally(() => {
        if (button instanceof HTMLButtonElement) button.disabled = false;
      });
  });
}

document.querySelectorAll('.bpd__form').forEach(bind);
